<template>
  <div v-if="!loading">
    <nav-header :title="header_title"></nav-header>
    <video
      :src="videoUrl"
      controls
      style="width: 100%; height: 200px; margin-top: 30px"
    ></video>
    <van-tabs title-active-color="#3ca7fa" color="#3ca7fa">
      <van-tab :title="item.name" v-for="(item, index) in navs" :key="index">
        <div class="cap-item chapters" v-if="index === 0">
          <van-collapse
            accordion
            v-model="activeName"
            @change="onChange"
            :border="false"
          >
            <van-collapse-item
              :title="item1.title"
              :name="index1 + 1"
              v-for="(item1, index1) in chapters"
              :key="index1"
            >
              <div
                class="videos"
                v-for="(item2, index2) in videos[item1.id]"
                :key="index2"
                @click="goStudy(item2.id, course.id)"
              >
                <template v-if="item2.id == lessonId">
                  <div class="video-title video-act">
                    <span class="text">{{ item2.title }}</span>
                  </div>
                  <div class="video-duration video-act">
                    <duration-text :duration="item2.duration"></duration-text>
                  </div>
                </template>
                <template v-else>
                  <div class="video-title">
                    <span class="text">{{ item2.title }}</span>
                  </div>
                  <div class="video-duration">
                    <duration-text :duration="item2.duration"></duration-text>
                  </div>
                </template>
              </div>
            </van-collapse-item>
          </van-collapse>
        </div>
      </van-tab>
    </van-tabs>
  </div>
</template>
<script>
import Vue from "vue";
import { Collapse } from "vant-green";
import { CollapseItem } from "vant-green";
import { Tabs } from "vant-green";
import { Tab } from "vant-green";
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Tabs);
Vue.use(Tab);
import { mapState } from "vuex";
import DurationText from "../../components/duration-text.vue";
import NavHeader from "../../components/nav-header.vue";

export default {
  components: {
    DurationText,
    NavHeader,
  },
  data() {
    return {
      id: this.$route.query.id,
      lessonId: 0,
      videoUrl: null,
      coverUrl: null,
      lessons: [],
      navs: [
        {
          name: "课节",
        },
      ],
      videos: {},
      chapters: [],
      activeName: "",
      loading: false,
      header_title: "课程详情",
    };
  },
  mounted() {
    this.getVideoPlayAuth(this.id);
  },
  computed: {
    ...mapState(["isLogin"]),
  },
  methods: {
    onChange(event) {
      console.log(event.detail);
      this.activeName = event.detail;
    },
    getVideoPlayAuth(id) {
      if (this.loading) {
        return;
      }
      this.loading = true;
      this.$api.Course.getVideoPlayAuth(id).then((res) => {
        this.loading = false;
        this.course = res.data.course;
        this.chapters = res.data.chapters;
        this.lessons = res.data.lessons;
        this.videoUrl = res.data.playURL;
        var that = this;
        var activeName = "";
        if (res.data.chapters.length > 0 && res.data.lessons.length > 0) {
          res.data.chapters.forEach(function (e, index) {
            that.videos[e.id] = [];
            res.data.lessons.forEach(function (k) {
              if (e.id == k.chapterId) {
                that.videos[e.id].push(k);
              }
              if (id == k.id && activeName == "" && e.id == k.chapterId) {
                that.activeName = index + 1;
              }
            });
          });
        }
      });
    },
    goStudy(id, cid) {
      if (!this.isLogin) {
        this.$router.push({
          name: "Login",
          query: {
            url: window.location.href,
          },
        });
        return;
      }
      if (!this.course.userCanJoin) {
        this.$message.error("暂无权限");
        return;
      }
      this.getVideoPlayAuth(id);
      return;
    },
  },
};
</script>
<style>
.videos {
  width: 90%;
  height: auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  line-height: 36px;
  box-sizing: border-box;
  padding: 0 10px 0 10px;
  background: #f6f6f6;
  border-radius: 4px;
  margin: 0 auto;
}

.video-title {
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 14px;
  color: #333;
}

.video-duration {
  width: auto;
  height: auto;
  font-size: 12px;
  margin-left: 10px;
  color: #999999;
}

.video-act {
  color: #3ca7fa;
}
</style>
